import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { theme } from "shared/lib/styles";

import { ResponsiveContainer } from "scmp-app/components/header/features/styles";
import IconLogoStyleText from "scmp-app/components/header/icon-logo-style-text.svg";

export const Container = styled(ResponsiveContainer)``;

export const StyledLogoLink = styled(BaseLink)`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`;

export const StyledStyleLogoText = styled(IconLogoStyleText)`
  inline-size: auto;
  block-size: 24px;
  margin-block-start: 4px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 42px;
    block-size: 26.46px;
  }
`;
